import { DocumentData, DocumentFields } from "./../types";

export function makeCryptoControlBlock(
  document: DocumentData | DocumentFields[]
): string {
  const block = [];

  if (Array.isArray(document)) {
    for (const field of document) {
      block.push(field.prefix);
      block.push(field.value);
      block.push(field.suffix);
    }
  } else {
    block.push(document.header);
    if (document.data?.length) {
      for (const field of document.data) {
        block.push(field.prefix);
        block.push(
          field.entity
            ? makeCryptoControlBlock(
                field?.childValue as Required<DocumentData>
              )
            : field.value
        );
        block.push(field.suffix);
      }
    }

    block.push(document.footer);
  }

  return block.join("");
}
